import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

const queryFn = (accessToken: string, carbonReductionMeasureUid: string) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            carbonReductionMeasureUid,
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then(
        (data) =>
            data.measure.annualCashFlowChart as ProjectReportAnnualCashFlowChart
    );

const query = graphql(`
    query annualCashFlowChartProjectReport($carbonReductionMeasureUid: Uuid!) {
        measure(carbonReductionMeasureUid: $carbonReductionMeasureUid) {
            annualCashFlowChart {
                total {
                    carbonPolicyCostSavings
                    calendarYear
                    cashFlowAnnual
                    cashFlowCumulative
                    incrementalCost
                    revenue
                    utilityCostSavingsElectricity
                    utilityCostSavingsNaturalGas
                    likeForLikeCost
                    totalIncentives
                }
                incremental {
                    carbonPolicyCostSavings
                    calendarYear
                    cashFlowAnnual
                    cashFlowCumulative
                    incrementalCost
                    revenue
                    utilityCostSavingsElectricity
                    utilityCostSavingsNaturalGas
                    totalIncentives
                }
            }
        }
    }
`);

export default queryFn;
